import { Component, OnInit, ViewChild, ViewChildren, ElementRef, Inject, Input, QueryList } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

import { MatHorizontalStepper } from '@angular/material/stepper';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { PlayerComponent } from 'src/app/components/oneroll-player/player/player.component';
import { QuestionComponent } from 'src/app/components/oneroll-player/question/question.component';
import { StatisticsComponent } from 'src/app/components/oneroll-player/statistics/statistics.component';

import { FormService } from 'src/app/services/form.service';

import { Video } from 'src/app/models/video';
import { Content } from 'src/app/models/content';
import { Trigger } from 'src/app/models/trigger';
import { ContentList } from 'src/app/models/content-list';
import { Question } from 'src/app/models/question';
import { QuestionSelect } from 'src/app/models/question-select';
import { Playlist } from 'src/app/models/playlist';
import { CtaSimple } from 'src/app/models/cta-simple';
import { MessageSimple } from 'src/app/models/message-simple';
import { FormOverlay } from 'src/app/models/form-overlay';
import { FormExpand } from 'src/app/models/form-expand';

import { CssHelper } from 'src/app/helpers/css-helper';

import HexRgb from 'hex-rgb';

@Component({
  selector: 'app-playlist',
  templateUrl: './playlist.component.html',
  styleUrls: ['./playlist.component.scss']
})
export class PlaylistComponent implements OnInit {

  @Input() playlist:Playlist;

  responsible: boolean;
  lp: boolean = false;

  style:SafeHtml;

  currentMainContents:Array<Content | Video> = [];
  currentMainContent:Content | Video = null;

  currentSubContents:Array<Content | Video> = [];
  currentSubContent:Content = null;

  // currentContentList:ContentList;

  triggers:Array<Trigger> = [];
  currentTrigger:Trigger;
  currentSubContentListHash:string | null = null;

  isNeedPassword:boolean = false;
  imagePassword:string;

  isPreviewMode:boolean = false;
  isShowSubContents:boolean = false;

  currentContentListSubContentsCount:number | false = false;

  answeredQuestionHashValues:{
    questionHash: string,
    value: any,
    mainContentHash: string,
    subContentListHash?: string,
    sent?: boolean
  }[] = [];

  // @ViewChild('playerComponent', {static: false}) playerComponent: PlayerComponent;
  @ViewChildren('playerComponents') playerComponents: QueryList<PlayerComponent>;

  @ViewChild('mainContentsStepper', {static: false}) mainContentsStepper: MatHorizontalStepper;
  @ViewChild('subContentsStepper', {static: false}) subContentsStepper: MatHorizontalStepper;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    @Inject(DOCUMENT) public document: any,
    private domSanitizer: DomSanitizer,
    public formService: FormService,
  ) { }

  ngOnInit() {

    const responsible = document.getElementById("html-root").classList.contains("responsible");
    if(responsible){
      this.responsible = true;
    }

    const lp = document.getElementById("html-root").classList.contains("lp");
    if(lp){
      this.lp = true;
    }

    let url = new URL(window.location.href);
    const isAutoPlay = url.searchParams.get("autostart") == '1' ? true : false;
    this.initPlaylist(isAutoPlay);
  }

  initPlaylist(autoplay = false){

    this.currentMainContents = [];
    this.currentMainContent = null;

    this.currentSubContents = [];
    this.currentSubContent = null;

    this.triggers = [];
    this.currentTrigger = null;
    this.currentSubContentListHash = null;

    this.isNeedPassword = false;
    this.isPreviewMode = false;
    this.isShowSubContents = false;

    if(! this.playlist){
      if(this.data && this.data.orpv){
        window.orpv = this.data.orpv;
      }

      // @ts-ignore
      let orpvObject = JSON.parse(window.orpv);

      if(orpvObject.password){
        this.isNeedPassword = true;
        this.imagePassword = orpvObject.image;
      }

      if(orpvObject.isPreviewMode){
        this.isPreviewMode = true;
      }

      let playlistObject = orpvObject.playlist;
      this.playlist = new Playlist(playlistObject);
    }

    // currentMainContentsに最初のmainContentをセット
    this.currentMainContent = this.playlist.getMainContent(this.playlist.startAt);
    if(this.currentMainContent && this.currentMainContent.type == "Video" && autoplay){
      const mainContentVideo = this.currentMainContent as Video;
      mainContentVideo.autoplay = true;
    }
    this.currentMainContents.push(this.currentMainContent);

    let style = CssHelper.getCss(this.playlist.color);
    style = "<style>" + style + "</style>";
    this.style = this.domSanitizer.bypassSecurityTrustHtml(style);
  }

  playerTriggered(triggers:Array<Trigger>){

    for(let trigger of triggers){
      this.triggers.push(trigger);
    }

    this.triggered();
  }

  triggered(){

    // 基本はtriggerで指定された次のコンテンツに移動する

    const currentPlayerComponent = this.playerComponents.find((component:PlayerComponent) => {
      let video = this.currentMainContent as Video;
      if(component.video == video){
        return true;
      }
    });

    // SubContentListから出る判定と一括送信
    const isLeavingSubContentList = this.currentSubContentListHash && (
      this.triggers.length === 0 || // 次の行き先がない
      this.triggers[0]?.nextType === "MainContent" || // MainContentに移動
      (this.triggers[0]?.nextType === "SubContentList" &&
       this.triggers[0]?.nextSubContentListHash !== this.currentSubContentListHash) // 別のSubContentList
    );

    if(isLeavingSubContentList){
      this.sendBatchQuestionAnswers(this.currentSubContentListHash);
    }

    // 次の行き先がない場合は終了
    if(this.triggers.length == 0){
      // console.log("トリガーなし！");

      // SubContentList内であれば動画を再生
      if(currentPlayerComponent){
        currentPlayerComponent.isTriggered = false;

        if(currentPlayerComponent.player){
          // まだ再生していない場合、または、終わりまでに0.1秒以上あれば再生
          if(! currentPlayerComponent.player.getDuration()){
            currentPlayerComponent.play();
          }
          else if(currentPlayerComponent.player.getDuration() > currentPlayerComponent.player.getPosition() + 0.1){
            currentPlayerComponent.play();
          }
          if(! currentPlayerComponent.video?.userVideo?.live){
            currentPlayerComponent.enablePlayKeyEvent();
          }
        }
      }

      this.isShowSubContents = false;
      this.currentSubContent = null;
      this.currentSubContents = [];
      this.currentContentListSubContentsCount = false;
      this.currentSubContentListHash = null;
      this.subContentsStepper.reset();
      return;
    }

    if(currentPlayerComponent){
      currentPlayerComponent.disablePlayKeyEvent();
    }

    // 次のトリガーを取得
    this.currentTrigger = this.triggers[0];
    this.currentTrigger.triggered = true;


    // 今トリガーされたtriggerを削除
    this.triggers.splice(0, 1);

    // 次の行き先が別のMainContentの場合
    if(this.currentTrigger.nextType == "MainContent"){
      // SubContentList/SubContentの表示状態をリセット
      this.isShowSubContents = false;
      this.currentSubContent = null;
      this.currentSubContents = [];
      this.subContentsStepper.reset();

      // currentMainContentsに最初のmainContentをセット
      this.currentMainContent = this.playlist.getMainContent(this.currentTrigger.nextMainContentHash);
      if(this.currentMainContent && this.currentMainContent.type == "Video"){
        const mainContentVideo = this.currentMainContent as Video;
        mainContentVideo.autoplay = true;
      }
      this.currentMainContents.push(this.currentMainContent);
      this.currentContentListSubContentsCount = false;
      this.currentSubContentListHash = null;

      setTimeout(() => {
        this.mainContentsStepper.next();
      }, 200);
    }
    // 次の行き先が同じMainContentのSubContentListの場合
    else if(this.currentTrigger.nextType == "SubContentList" && this.currentTrigger.nextMainContentHash == this.currentMainContent.hash){
      // SubContentListに入る
      this.currentSubContentListHash = this.currentTrigger.nextSubContentListHash;

      // currentMainContentsに最初のmainContentをセット
      let nextSubContentList = this.playlist.getSubContentList(this.currentTrigger.nextMainContentHash, this.currentTrigger.nextSubContentListHash);
      this.currentSubContent = this.playlist.getSubContent(this.currentTrigger.nextMainContentHash, this.currentTrigger.nextSubContentListHash, nextSubContentList.startAt);
      this.currentSubContents.push(this.currentSubContent);

      this.currentContentListSubContentsCount = nextSubContentList.getSubContentsCountForOnlyNoBranch();

      setTimeout(() => {
        this.isShowSubContents = true;
        // 次のコンテンツが最初のページでなければ移動
        if(this.currentSubContent != this.currentSubContents[0]){
          this.subContentsStepper.next();
        }
      }, 200);
    }
    // 次の行き先が同じMainContentのSubContentの場合
    else if(this.currentTrigger.nextType == "SubContent" && this.currentTrigger.nextMainContentHash == this.currentMainContent.hash){
      // currentMainContentsに最初のmainContentをセット
      const nextSubContent = this.playlist.getSubContent(this.currentTrigger.nextMainContentHash, this.currentTrigger.nextSubContentListHash, this.currentTrigger.nextSubContentHash);
      this.currentSubContent = nextSubContent;
      
      // 同じハッシュのサブコンテンツが既に存在しない場合のみ追加（重複防止）
      if(! this.currentSubContents.find(subContent => subContent.hash === nextSubContent.hash)){
        this.currentSubContents.push(this.currentSubContent);
      }

      setTimeout(() => {
        // console.log("SubContent triggered");
        this.isShowSubContents = true;
        // 次のコンテンツが最初のページでなければ移動
        const currentIndex = this.currentSubContents.findIndex(content => content.hash === this.currentSubContent.hash);
        const stepperIndex = this.subContentsStepper.selectedIndex;
        
        if(currentIndex > stepperIndex){
          // console.log("subContentsStepper next");
          this.subContentsStepper.next();
        } else if(currentIndex < stepperIndex){
          // console.log("subContentsStepper previous");
          this.subContentsStepper.previous();

          // ステッパーを戻した後、後続のコンテンツを削除
          const currentIndex = this.subContentsStepper.selectedIndex;
          this.currentSubContents.splice(currentIndex + 1);
        }
        // console.log("this.currentSubContents", this.currentSubContents);

      }, 200);
    }

  }

  questionSkipped(question:any){
    // Skipされたら回答をリセット
    question.value = null;

    this.triggerQuestion(question);
    return;  
  }

  questionInputed(question:any){
    if(question.value == null || question.value == ''){
      // console.log("A 値はNULLまたは空文字の場合、送信しない");
      this.triggerQuestion(question);
      return;
    }

    const answeredQuestionHashValue = this.answeredQuestionHashValues.find(answeredQuestionHashValue => answeredQuestionHashValue.questionHash === question.hash);
    if(answeredQuestionHashValue){
      if(answeredQuestionHashValue.value == question.value){
        // console.log("B 同じ設問で同じ回答値の場合、再送信しない");
        this.triggerQuestion(question);
        return;
      }
      else{
        // console.log("C 回答が存在して同じ回答値でない場合、回答値を上書き");
        answeredQuestionHashValue.value = question.value;
        // 値が変更されたので未送信状態にリセット
        answeredQuestionHashValue.sent = false;
      }
    }
    else{
      // console.log("D 同じ設問の回答がリストに存在しない場合はリストに追加");
      this.answeredQuestionHashValues.push({
        questionHash: question.hash,
        value: question.value,
        mainContentHash: this.currentMainContent.hash,
        subContentListHash: this.currentSubContentListHash || undefined,
        sent: false
      });
    }

    // console.log("questionInputed", question);

    // SubContentList外（MainContent）の場合は即座に送信
    if(!this.currentSubContentListHash){
      let data = {
        playlistHashPublic: this.playlist.playlistHashPublic ? this.playlist.playlistHashPublic : null,
        userVideoHashPublic: this.playlist.videoHashPublic ? this.playlist.videoHashPublic : null,
        questionHash: question.hash,
        value:question.value
      };
      if(window.onerollq){
        window.onerollq('QuestionPost', data);
      }
      // 送信済みフラグを立てる
      const answer = this.answeredQuestionHashValues.find(a => a.questionHash === question.hash);
      if(answer){
        answer.sent = true;
      }
    }
    // SubContentList内の場合は保留（triggered()で一括送信）

    this.triggerQuestion(question);
  }

  triggerQuestion(question){
    let trigger:Trigger;

    // contentのcontentTriggerを入れる
    if(question.trigger){
      trigger = question.trigger;
    }

    if(question.type == "QuestionSelect"){
      question = question as QuestionSelect;
      for(let option of question.options){
        if(option.key != question.value){
          continue;
        }
        if(! option.trigger){
          break;
        }
        // optionのcontentTriggerを入れる
        trigger = option.trigger;
      }
    }

    // 次のtriggerがあれば確認
    if(trigger){
        this.triggers.splice(0, 0, trigger);
    }
    this.triggered();
  }


  async formOverlayInputed(content:FormOverlay){

    // skipされた場合
    if(! content){
      this.triggered();
      return;
    }

    let values = {
      formHash: content.form.hash,
      formDatas: null,
      visitorHash: null,
      sessionHash: null,
      device: null,
      referrer: null,
      cIId: null,
      videoParameterKey: null,
    };

    if(window.onerollTrack){
      if(window.onerollTrack.visitorHash){
        values.visitorHash = window.onerollTrack.visitorHash;
      }
      if(window.onerollTrack.sessionHash){
        values.sessionHash = window.onerollTrack.sessionHash;
      }

      values.device = window.onerollTrack.getDevice();
      values.referrer = document.referrer;

      if(window.onerollTrack.campaignIndexId){
        values.cIId = window.onerollTrack.campaignIndexId;
      }
      if(window.onerollTrack.videoParameterKey){
        values.videoParameterKey = window.onerollTrack.videoParameterKey;
      }
    }

    let formDatas = content.getFormDatasObject();
    values.formDatas = formDatas;

    // PostFormAPIを実行
    try{
      this.formService.postLeadForm(values);
    }
    catch(e){
      console.log(e);
    }

    if(window.onerollTrack){
      window.onerollTrack.enableProspect();
    }

    let trigger:Trigger;
    // contentのcontentTriggerを入れる
    if(content.trigger){
      trigger = content.trigger;
    }
    if(trigger){
        this.triggers.splice(0, 0, trigger);
    }
    this.triggered();
  }

  async formExpandInputed(content:FormExpand){

    let values = {
      formHash: content.form.hash,
      formDatas: null,
      visitorHash: null,
      sessionHash: null,
      device: null,
      referrer: null,
    };

    if(window.onerollTrack){
      if(window.onerollTrack.visitorHash){
        values.visitorHash = window.onerollTrack.visitorHash;
      }
      if(window.onerollTrack.sessionHash){
        values.sessionHash = window.onerollTrack.sessionHash;
      }
      values.device = window.onerollTrack.getDevice();
      values.referrer = document.referrer;
    }

    let formDatas = content.getFormDatasObject();
    values.formDatas = formDatas;

    // PostFormAPIを実行
    try{
      await this.formService.postLeadForm(values);
    }
    catch(e){

    }

    if(content.form.sendCompleteType == 1){
      window.location.href = content.form.sendCompleteRedirectUrl;
    }
    if(content.form.sendCompleteType == 2){

    }

  }

  ctaSimpleCtaClicked(event:{content: CtaSimple}){
    const content = event.content;

    // SubContentList内でCTAがクリックされた場合、溜まっている回答を送信
    if(this.currentSubContentListHash){
      this.sendBatchQuestionAnswers(this.currentSubContentListHash);
    }

    let trigger:Trigger;

    let currentVideo:Video;
    if(this.currentMainContent.type == "Video"){
      currentVideo = this.currentMainContent as Video;
    }

    // console.log("ctaSimpleCtaClicked", content.legacy);

    // 通常CTAとアンケートの場合のCTA
    if(window.onerollq){
      // Trackに送信
      let data = {
        userVideoHashPublic: null,
        hash: content.hash,
        title: content.title,
        url:content.linkUrl,
      };
      if(currentVideo){
        data.userVideoHashPublic = currentVideo.userVideo.hashPublic;
      }
      window.onerollq('CtaUpdate', data);
    }

    // アンケートの場合のCTA
    if(window.onerollq && ! content.legacy){
      // Trackに送信
      let data = {
        playlistHashPublic: this.playlist.playlistHashPublic ? this.playlist.playlistHashPublic : null,
        userVideoHashPublic: this.playlist.videoHashPublic ? this.playlist.videoHashPublic : null,
        questionHash: content.hash,
        value:content.linkUrl
      };
      window.onerollq('QuestionPost', data);
    }

  }

  ctaSimpleforwardClicked(event:{content: CtaSimple}){

    const content = event.content;

    let trigger:Trigger;

    // contentのcontentTriggerを入れる
    if(content.trigger){
      trigger = content.trigger;
    }

    // 次のtriggerがあれば確認
    if(trigger){
        this.triggers.splice(0, 0, trigger);
    }
    this.triggered();
  }

  messageSimpleforwardClicked(content:MessageSimple){

    // this.currentTrigger.triggered = true;

    let trigger:Trigger;

    // contentのcontentTriggerを入れる
    if(content.trigger){
      trigger = content.trigger;
    }

    // 次のtriggerがあれば確認
    if(trigger){
        this.triggers.splice(0, 0, trigger);
    }
    this.triggered();
  }

  messageSimpleLinkClick(values:{content:MessageSimple, linkUrl:string, title:string}){

    let currentVideo:Video;
    if(this.currentMainContent.type == "Video"){
      currentVideo = this.currentMainContent as Video;
    }

//    console.log("messageSimpleLinkClick");

    // CTAクリックしたら送信
    if(window.onerollq){
      let data = {
        userVideoHashPublic: null,
        hash: values.content.hash,
        title:values.title,
        url:values.linkUrl,
      };
      if(currentVideo){
        data.userVideoHashPublic = currentVideo.userVideo.hashPublic;
      }
      window.onerollq('CtaUpdate', data);
    }
  }

  recommendChecked(event){}
  statisticsChecked(event){}

  backToPrev(){
    if(! this.subContentsStepper){
      return;
    }

    this.subContentsStepper.previous();
    
    // ステッパーを戻した後、後続のコンテンツを削除
    const currentIndex = this.subContentsStepper.selectedIndex;
    this.currentSubContents.splice(currentIndex + 1);
    
    this.currentSubContent = this.currentSubContents[currentIndex];
    // console.log("currentSubContent", this.currentSubContent);
  }

  reloadPlaylist(){
    this.playlist = null;
    // Password入力後は自動再生を有効
    this.initPlaylist(true);
  }

  backToTop(){
    this.playlist = null;
    setTimeout(() => {
      this.initPlaylist();
    }, 100);
  }

  getProgressWidth(){
    if(! this.subContentsStepper){
      return;
    }
    if(this.currentContentListSubContentsCount === false){
      return false;
    }
    return (this.subContentsStepper.selectedIndex + 1) / this.currentContentListSubContentsCount * 100 + '%';
  }

  // SubContentListの質問回答を一括送信
  private sendBatchQuestionAnswers(subContentListHash: string){
    // 指定されたSubContentListの未送信の回答のみをフィルタリング
    const answersToSend = this.answeredQuestionHashValues.filter(answer =>
      answer.subContentListHash === subContentListHash && !answer.sent
    );

    if(answersToSend.length === 0){
      // console.log("No answers to send for SubContentList:", subContentListHash);
      return;
    }

    // console.log("Sending batch question answers:", answersToSend);

    // 一括送信
    for(let answer of answersToSend){
      let data = {
        playlistHashPublic: this.playlist.playlistHashPublic ? this.playlist.playlistHashPublic : null,
        userVideoHashPublic: this.playlist.videoHashPublic ? this.playlist.videoHashPublic : null,
        questionHash: answer.questionHash,
        value: answer.value
      };
      if(window.onerollq){
        window.onerollq('QuestionPost', data);
      }
      // 送信済みフラグを立てる
      answer.sent = true;
    }
  }

  // exitFullscreen(){

  //   if(! this.document.fullscreenElement){
  //     return;
  //   }

  //   if (this.document.exitFullscreen) {
  //     this.document.exitFullscreen();
  //   } else if (this.document.mozCancelFullScreen) {
  //     /* Firefox */
  //     this.document.mozCancelFullScreen();
  //   } else if (this.document.webkitExitFullscreen) {
  //     /* Chrome, Safari and Opera */
  //     this.document.webkitExitFullscreen();
  //   } else if (this.document.msExitFullscreen) {
  //     /* IE/Edge */
  //     this.document.msExitFullscreen();
  //   }
  // }
  getMainContentVideo(){
    if(! this.currentMainContent){
      return;
    }
    if(! (this.currentMainContent instanceof Video)){
      return;
    }
    return this.currentMainContent;
  }

}